<template>
  <Disclosure as="nav" class="bg-accent-black" v-slot="{ open }">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-20">
        <div class="flex items-center w-full">
          <div class="flex-shrink-0">
            <img
              class="w-52"
              src="@/assets/img/Accent_Logo_WebHeader.png"
              alt="Workflow"
            />
          </div>
          <!-- The items in the navbar are dynamic (besides sign out) -->
          <div class="hidden md:block w-full">
            <div class="ml-10 w-full flex justify-end space-x-4">
              <router-link
                active-class="border-b-4 border-accent-green"
                class="text-white hover:text-gray-300 transiton-all"
                v-for="item in navigation"
                :key="item.name"
                :to="item.href"
                >{{ item.name }}</router-link
              >
              <button
              @click="signOut()"
                class="text-white hover:text-gray-300 transiton-all border-b-4 border-accent-black"
                >Sign Out</button
              >
            </div>
          </div>
        </div>
        <div class="-mr-2 flex md:hidden">
          <!-- Mobile menu button -->
          <DisclosureButton
            class="bg-accent-green inline-flex items-center justify-center p-2 rounded-md text-white hover:text-white hover:bg-accent-green-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
          >
            <span class="sr-only">Open main menu</span>
            <MenuIcon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
            <XIcon v-else class="block h-6 w-6" aria-hidden="true" />
          </DisclosureButton>
        </div>
      </div>
    </div>

    <DisclosurePanel class="md:hidden">
      <div class="px-2 pt-2 pb-3 space-y-1 sm:px-3">
        <router-link
          v-for="item in navigation"
          :key="item.name"
          :to="item.href"
          active-class="bg-accent-cyan-dark"
          class="text-gray-300 hover:bg-gray-700 hover:text-white
            block px-3 py-2 rounded-md text-base font-medium"
          :aria-current="item.current ? 'page' : undefined"
          >{{ item.name }}</router-link
        >
        <button
          class="text-gray-300 hover:bg-gray-700 hover:text-white
            block px-3 py-2 rounded-md text-base font-medium" 
          >Sign Out</button>
      </div>
      <div class="pt-4 pb-3 border-t border-gray-700">
        <div class="flex items-center px-5">
          <div class="flex-shrink-0">
            <img class="h-10 w-10 rounded-full" alt="" />
          </div>
          <div class="ml-3">
            <div class="text-base font-medium leading-none text-white">
              {{ user.name }}
            </div>
            <div class="text-sm font-medium leading-none text-gray-400">
              {{ user.email }}
            </div>
          </div>
        </div>
        <div class="mt-3 px-2 space-y-1">
          <DisclosureButton
            v-for="item in userNavigation"
            :key="item.name"
            as="a"
            :href="item.href"
            class="block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700"
            >{{ item.name }}</DisclosureButton
          >
        </div>
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script>
import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { MenuIcon, XIcon } from "@heroicons/vue/outline";

const user = {
  name: "USER USER",
  email: "USER@USER.COM",
  imageUrl:
    "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
};

const userNavigation = [
  { name: "Your Profile", href: "Home" },
  { name: "Settings", href: "About" },
  { name: "Sign out", href: "SignIn" }
];

export default {
  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    MenuIcon,
    XIcon
  },
  data() {
    return {
      count: 0,
      navigation: [
        { name: "Catalogue", href: { name: "Catalogue" } },
        { name: "My Info", href: { name: "MyInfo" } },
        { name: "My Orders", href: { name: "MyOrders" } },
        { name: "PO Orders", href: { name: "MyPOOrders" } },
        { name: "Reports", href: { name: "MyReports" } },
        { name: "Support", href: { name: "Support" } }
      ]
    };
  },
  setup() {
    return {
      user,
      userNavigation
    };
  },
  methods: {
    signOut() {
      this.mainStore.signOut();
    }
  }
};
</script>
